import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {catchError, throwError} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(private http: HttpClient) { }

  public getNotification(transactionBookingId: number) {
    return this.http.get(`transaction-booking-notification?TransactionBookingId=${transactionBookingId}`).pipe(
      catchError(error => {
        console.error('Error occurred:', error);
        return throwError(error);
      })
    );
  }

  public updateNotification(notificationId: number, isSynced: boolean) {
    return this.http.put('transaction-booking-notification', {
      id: notificationId,
      isSynced: isSynced
    }).pipe(
      catchError(error => {
        console.error('Error occurred:', error);
        return throwError(error);
      })
    );
  }
}
